import useDeviceType from "../common/useDeviceType";

export default function SMHeroBanner() {
  const isMobile = useDeviceType();
  return (
    <section className="relative w-full h-full">
      <div className="relative w-full h-full max-w-screen-xl mx-auto px-3 lg:px-0">
        {/* 광택 스윕(빛이 사선으로 스윽 지나감, 계속 반복) */}
        <div className="relative overflow-hidden">
          <img
            className="w-full"
            src={isMobile ? "/images/bannerMo.png" : "/images/banner.png"}
            alt="하수구원킬케어 베너"
          />
          <span
            aria-hidden="true"
            className="pointer-events-none absolute inset-y-0 left-0 w-1/3 bg-gradient-to-r from-transparent via-white/40 to-transparent animate-shine motion-reduce:hidden"
          />
        </div>

        {/* 떠오르는 물방울(청량감) */}
        <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-0 overflow-hidden motion-reduce:hidden"
        >
          <span className="absolute left-[15%] bottom-6 w-3 h-3 rounded-full bg-[#043fff]/30 blur-[1px] animate-bubble-rise [animation-delay:0s]" />
          <span className="absolute left-[45%] bottom-10 w-2 h-2 rounded-full bg-white/60 blur-[1px] animate-bubble-rise [animation-delay:1.6s]" />
          <span className="absolute left-[70%] bottom-4 w-4 h-4 rounded-full bg-[#4d7bff]/25 blur-[1px] animate-bubble-rise [animation-delay:3s]" />
          <span className="absolute left-[85%] bottom-8 w-2.5 h-2.5 rounded-full bg-[#043fff]/25 blur-[1px] animate-bubble-rise [animation-delay:2.2s]" />
        </div>
      </div>
    </section>
  );
}
